import cx from 'classnames';
import { STROLLER_ADD_WISHLIST } from 'mk/autogenerated/translations/WishlistToggle.8925487a1d7ed10a323ca6bce063acfe'
import React from 'react';
import styles from './WishlistToggle.mscss';

interface OwnProps {
    active: boolean;
    showBig?: boolean;

    onClick(strollerId);
}

export class WishlistToggle extends React.Component<OwnProps> {

    public static defaultProps: Partial<OwnProps> = {
    };

    public render() {
        const { active, showBig, onClick } = this.props;

        return (
            <div className={styles.WishlistToggle} onClick={onClick}>
                {(showBig) ? (
                    <a className={styles.WishlistToggle__big}>
                        <i className={cx('fa', (!active) ? 'fa-star-o' : 'fa-star', styles['WishlistToggle__big--icon'], (!active) ? styles['WishlistToggle__big--iconInactive'] : styles['WishlistToggle__big--iconActive'])}/>
                        {STROLLER_ADD_WISHLIST}
                    </a>
                ) : (
                    <button className={styles.WishlistToggle__small}>
                        <i className={cx('fa', (!active) ? 'fa-star-o' : 'fa-star', styles['WishlistToggle__small--icon'], (!active) ? styles['WishlistToggle__small--iconInactive'] : styles['WishlistToggle__small--iconActive'])} />
                    </button>
                )}
            </div>
        );
    }
}
